<template>
	<div class="cbs-upload">
		<el-upload
			v-bind="computedAttrs"
			v-on="$listeners"
			:class="['cbs-upload__uploader', { 'cbs-upload__uploader--readonly': !isEditable, 'display-mode-input': displayMode === 'input' }]"
			name="upload"
			:list-type="listType"
			:drag="false"
			:action="uploadUrl"
			:file-list="localValue"
			:show-file-list="false"
			:on-progress="handleOnProgress"
			:on-change="handleOnChangeFiles"
			:before-upload="handleValidateFileSize"
			:accept="accept"
		>
			<vs-button v-if="displayMode === 'button'" class="font-bold" type="border" icon-pack="nucleo" icon="nucleo-file-upload-93">{{ title }}</vs-button>
			<div v-if="displayMode === 'input'" class="w-full text-left">
				<label for class="vs-input--label ">{{ title }}:</label>
				<vx-input-group>
					<template slot="append">
						<div class="append-text text-black">
							<i class="nucleo nucleo-file-upload-93"></i>
						</div>
					</template>
					<el-input :placeholder="localValue && localValue[0] && localValue[0].response ? localValue[0].response.file_name : 'Chưa có tập tin'"> </el-input>
				</vx-input-group>
			</div>
			<div v-if="displayMode !== 'button' && displayMode !== 'input'" slot="trigger">
				<i slot="default" class="el-icon-plus"></i>
			</div>

			<transition-group tag="div" name="el-list" class="el-upload-list el-upload-list--picture-card" v-if="displayMode === 'default'">
				<DefaultUploadMode
					v-for="file in localValue"
					:file="file"
					:key="file.uid"
					:isEditable="isEditable"
					@onClickRemove="handleRemove"
					@onClickPreview="handlePreview"
					@onClickDownload="handleDownload"
				/>
			</transition-group>

			<ListUploadMode v-else v-for="file in localValue" :file="file" :key="file.uid" @onClickItem="handlePreview" />
		</el-upload>

		<el-dialog v-if="dialogVisible && previewFile" class="custom-nested-dialog cbs-upload-preview" append-to-body :modal="false" :show-close="false" :visible.sync="dialogVisible">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-all">{{ previewFile.name }}</span>
				<i class="el-icon-download text-xl cursor-pointer font-bold" :title="$t('Actions.Download')" @click="() => handleDownload(previewFile)" />
			</div>
			<PerfectScrollbar class="p-6 text-center" :settings="settings">
				<img v-if="fileIsImage(previewFile.response.extension)" class="responsive" :src="previewFile.url" alt="" />

				<FileIcon v-else class="flex items-center justify-center" :extension="previewFile.response.extension" displayMode="default" />
			</PerfectScrollbar>

			<div class="flex justify-center" slot="footer">
				<vs-button type="border" class="w-full sm:w-1/2 lg:w-1/4 xl:w-1/5 font-bold" @click.stop="dialogVisible = false">{{ $t("Actions.Close") }}</vs-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import _ from "lodash";
// import { UPLOAD_FILE_SIZE_LIMIT } from "@/utils/constant";

import FileIcon from "./FileIcon";
import ListUploadMode from "./ListUploadMode";
import DefaultUploadMode from "./DefaultUploadMode";

const UPLOAD_FILE_SIZE_LIMIT = 10;

export default {
	name: "CbsUploadRef",
	inheritAttrs: false,
	components: { FileIcon, ListUploadMode, DefaultUploadMode },
	props: {
		value: {
			type: Array,
			// validator: prop => {
			// 	if (prop.length) {
			// 		return !prop.some(file => {
			// 			const isValidResponseObject = _.has(file, "id") && _.has(file, "path") && _.has(file, "extension") && _.has(file, "file_name");

			// 			return !isValidResponseObject;
			// 		});
			// 	}
			// 	return true;
			// },
			default: () => []
		},
		displayMode: {
			type: String,
			validator: prop => ["default", "list", "button", "input"].includes(prop),
			default: "default"
		},
		isEditable: {
			type: Boolean,
			default: true
		},
		accept: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: "ImportFile"
		}
	},
	data() {
		return {
			dialogTitle: "",
			dialogImageUrl: "",
			previewFile: null,
			dialogVisible: false,
			totalProgressingFiles: this.value ? this.value.length : 0,
			localValue: this.initLocalValue(this.formatLocalValue(this.value || [])),

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			uploadUrl: process.env.VUE_APP_UPLOAD_FILE_ENDPOINT
		};
	},
	computed: {
		computedAttrs: function() {
			return Object.assign({}, this.$attrs, { disabled: !this.isEditable });
		},
		parsedSuccessLocalValue() {
			const result = [];
			this.localValue.forEach(file => {
				if (file.status === "success") {
					result.push({
						url: file.response.path,
						name: file.response.file_name,
						response: {
							id: file.response.id,
							path: file.response.path,
							extension: file.response.extension,
							file_name: file.response.file_name
						}
					});
				}
			});
			return result;
		},
		listType() {
			return this.displayMode == "default" ? "picture-card" : "";
		}
	},
	watch: {
		value() {
			const parsedValue = this.formatLocalValue(this.value || []);
			if (JSON.stringify(_.sortBy(parsedValue, ["url"])) !== JSON.stringify(_.sortBy(this.parsedSuccessLocalValue, ["url"]))) {
				this.localValue = this.initLocalValue(parsedValue);
			}
		}
	},
	methods: {
		formatLocalValue(value) {
			console.log('value: ', value);
			return value.map(file => ({
				url: file.path,
				name: file.file_name,
				response: {
					id: file.id,
					path: file.path,
					extension: file.extension,
					file_name: file.file_name
				}
			}));
		},
		initLocalValue(files) {
			return files.map((file, index) => ({
				...file,
				status: file.status || "success",
				uid: file.uid || Date.now() + index
			}));
		},
		handleRemove(removedFile) {
			const removeIndex = this.localValue.findIndex(file => file.response.id === removedFile.response.id);
			if (removeIndex !== -1) {
				this.localValue.splice(removeIndex, 1);
			}
			this.$emit(
				"input",
				removeIndex
			);
			// this.$emit(
			// 	"input",
			// 	this.value.filter(file => file.id !== removedFile.response.id)
			// );
		},
		handlePreview(file) {
			if (file.response.extension === "pdf") {
				window.open(file.response.path, "_blank");
			} else if (
				file.response.extension === "ppt" ||
				file.response.extension === "pptx" ||
				file.response.extension === "doc" ||
				file.response.extension === "docx" ||
				file.response.extension === "xls" ||
				file.response.extension === "xlsx"
			) {
				window.open(`https://view.officeapps.live.com/op/embed.aspx?src=${file.response.path}`);
			} else {
				this.previewFile = file;
				this.dialogVisible = true;
			}
		},
		handleDownload(file) {
			this.handleDownloadFile(file.response);
		},
		handleOnProgress(event, file, fileList) {
			this.localValue = fileList;
			this.totalProgressingFiles = fileList.length;
		},
		handleOnChangeFiles(file, fileList) {
			const totalReadyFiles = fileList.filter(file => file.status === "ready").length;
			const totalFailedAndSuccessedFiles = fileList.filter(file => ["success", "fail"].includes(file.status)).length;
			if (totalReadyFiles === 0 && this.totalProgressingFiles === totalFailedAndSuccessedFiles) {
				const result = [];
				this.localValue.forEach(file => {
					if (file.status === "success") {
						result.push(file.response);
					}
				});
				this.$emit("input", result);
			}
		},
		handleValidateFileSize(file) {
			const fileSizeInMb = file.size / 1024 / 1024;
			if (fileSizeInMb > UPLOAD_FILE_SIZE_LIMIT) {
				this.$helper.notifyWarning({
					context: this,
					options: {
						text: this.$t("Notify.LimitFileSizeWarning", {
							unit: "MB",
							fileName: file.name || "",
							fileSize: UPLOAD_FILE_SIZE_LIMIT
						}),
						time: 8000
					}
				});
				return false;
			}
		}
	}
};
</script>

<style lang="scss">
.cbs-upload {
	.cbs-upload__uploader {
		&.cbs-upload__uploader--readonly {
			::v-deep .el-upload {
				display: none;
			}
		}

		::v-deep .el-upload--picture-card,
		.el-upload-list__item {
			width: 140px;
			height: 140px;
		}

		::v-deep .el-upload--picture-card {
			margin: 0 8px 8px 0;
		}
		&.display-mode-input {
			.el-upload {
				width: 100%;
			}
		}
	}
}

.cbs-upload-preview ::v-deep .el-dialog {
	width: auto;
	min-width: 50vw;

	.file-icon {
		font-size: 26rem;

		@media screen and (max-width: 992px) {
			font-size: 23rem;
		}

		@media screen and (max-width: 768px) {
			font-size: 20rem;
		}

		@media screen and (max-width: 576px) {
			font-size: 15rem;
		}
	}
}
</style>
